export { default } from './PortionSwitcher';
